<template>
    <div>
        <v-app-bar
            height="84"
            elevation="0"
            color="#FFFFFF"
            style="position: fixed; z-index: 1"
        >
            <v-toolbar-title>
                <v-img
                    :src="require('../assets/schooney_logo.png')"
                    class="my-3"
                    contain
                />
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <div class="d-flex align-center">
                <a id="localThai" @click="changeLocale('th','localThai','localEng')" style="color: #37323c; font-family:'prompt'; margin-top: 3px; ">ไทย</a>
                <v-divider class="mx-4 my-1" vertical ></v-divider>
                <a id="localEng" @click="changeLocale('en','localEng','localThai')" style="color: #37323c;">EN</a>
                <v-divider class="mx-5" vertical></v-divider>
                <v-badge bordered color="#00C487" dot offset-x="8" offset-y="8">
                    <v-menu offset-y style="transform-origin: right top;" >
                        <template v-slot:activator="{ on, attrs }" >
                            <a
                                class="icon-circle icon-circle--orange"
                                v-bind="attrs"
                                v-on="on"
                            >
                                <img src="../assets/user-icon.svg" />
                            </a>
                        </template>
                        <v-card class="dropdown-menu-list px-4 py-3 " id="avatar_badge" elevation="0">
                            <a href="/login" id="avatar_logout">{{ $t('message.common.logout') }}</a>
                        </v-card>
                    </v-menu>
                </v-badge>
            </div>
        </v-app-bar>
    </div>
</template>

<script>
import i18n from "@/i18n";
export default {
    name: "NavBar",
    methods: {
        changeLocale(locale,emUnderline,emNotunderline) {
            document.getElementById(emUnderline).style.textDecoration = 'underline'
            document.getElementById(emNotunderline).style.textDecoration = 'none'
            localStorage.setItem("language", locale);
            i18n.locale = locale;
        },
    },
    mounted() {
        if (
            localStorage.getItem("language") == null ||
            localStorage.getItem("language") == undefined
        ) {
            localStorage.setItem("language", "th");
        }

        if(localStorage.getItem("language")==='th'){
            this.changeLocale(localStorage.getItem("language"),'localThai','localEng');
        }
        else{
            this.changeLocale(localStorage.getItem("language"),'localEng','localThai');
        }
            
    },
};
</script>

<style scoped>
#avatar_logout{
    color: #37323c;
    text-decoration: none;
}

#avatar_badge{ 
    box-shadow: 0px 0px 0px 0px transparent;
}

.clicked{
    text-decoration: underline;
}
</style>
